module.exports = __webpack_public_path__ + "static/logo-ivolga-cae7024230aa0f94367f5151b0b2570b.svg";